let account = {
    title: "Account security",
    haveSet: "Have set",
    noSet: "Not set",
    isBind: "Is binding",
    noBind: "No binding",
    activated: "Activated",
    nonactivated: "Nonactivated",
    edit: "Modify",
    set: "Set",
    bind: "Binding",
    activate: "Activate",
    reset: "Reset",
    noPhone: "To verify your identity, please bind your mobile phone number first!",
    look: "View",
    pghoess:"Phone",
    phonePlaceholder: "Please enter your mobile phone number",
    phoneErr: "The format of the mobile phone number is incorrect. Please enter it again",
    code: "Verification code",
    codePlaceholder: "Please enter the verification code",
    typePlaceholder:"Please select a token serial number",
    code6: "Please enter a 6-digit verification code",
    getCode: "Get code",
    offlineCode: "Offline QR code",
    pwd: "Password",
    pwdPlaceholder: "Please enter your password",
    ema: "Mailbox",
    emailPlaceholder: "Please enter email address",
    login: {
        title: "Login password",
        text: "A password with high security can make your account more secure. You are advised to change your password periodically. ",
        editPwd: "Change password",
        setPwd: "Set password",
        affirmPwd: "Confirm password",
        affirmPwdPlaceholder: "Please enter a valid Confirmation password",
        oldPwd: "Original password",
        newPwd: "New password",
        newPwdPlaceholder: "Please enter a new password",
        oldPwdMsg: "Please enter your old password",
    },
    setting: {
        title: "Multi-factor authentication mode",
        text: "You can see detailed information here about all the supported MFA methods."
    },
    phone: {
        title: "Bind mobile phone",
        tip01: "Bound with phone:",
        editPhone: "Modifying a Bound Mobile phone",
        tip02: ",bind mobile phone to protect account.",
        tip03: "To ensure the security of your account, please bind your mobile phone number in time.",
    },
    email: {
        title: "Bind email address",
        tip01: "Bound with email: ",
        editEmail: "Modify email",
        tip02: ", bind email address to protect account.",
        tip03: "To ensure the security of your account, bind the mailbox in time.",
        msg: "Please enter the correct email format",
        emailError:"Mailbox format error"
    },
    hardware: {
        title: "OTP hardware token",
        tip01: "Is binding",
        unbind: "Unbind the token",
        binds:"Bind the token",
        bindToken:"Bind OTP hardware token",
        bind: "BIND",
        unbindTabs: "UNBIND",
        tip02: "A token,You can obtain dynamic passwords using OTP hardware tokens to ensure account security.",
        tip03: "After binding, you can obtain dynamic passwords using OTP hardware tokens to ensure account security.",
        num: "Token serial number",
        numPlaceholder: "Please enter the token serial number",
        code: "Dynamic password",
        codePlaceholder: "Please enter a dynamic password",
        bindOrUnbind:"Bind/Unbind the token",
        bindOrUnbindOtp:"Bind/Unbind OTP hardware token",
        typePlaceholder:"Please select a token serial number",
    },
    FIDOU2F: {
        title: "FIDO hardware token",
        tip01: "You have successfully bound ",
        tip02: " token(s). You can quickly authenticate with the FIDO hardware token to ensure account security.",
        tip03: "After binding, you can quickly authenticate with FIDO hardware token to ensure account security.",
        deviceName: "Device name",
        selectName: "Please Select a device name",
        devicePlaceholder: "Please enter the device name",
        device: "Please insert FIDO hardware token device, and then click the start binding button. When the device indicator blinks, tap the button to complete the binding!",
        unbind: "Unbundling token",
        device32: "The device name contains a maximum of 32 characters",
        bind: "Start binding",
        deviceErr: "Binding token cancelled!",
        deviceRepetition: "Tokens do not allow double binding!",
        failure: "FIDO hardware token operation failed",
        bindSuccess: "Binding success",
        bindOrUnbindFIDOU2f:"Bind/unbind FIDO hardware token",
        bindToken:"Bind FIDO hardware token",
    },
    dynamic: {
        title: "Feitian Cloudentify APP (OTP)",
        resetDynamic: "Reset Feitian Cloudentify APP (OTP)",
        activateDynamic: "Activate Feitian Cloudentify APP (OTP)",
        text: "Feitian Cloudentify APP can generate OTP for login, or use its push notification for fast login.",
        tip01: "You have been successfully activated Feitian Cloudentify APP (OTP)，You can use the FEITIAN Cloud signaling APP Get dynamic password login, Or fast login through push authentication.",
        tip02: "After activation, You will be able to pass FEITIAN Cloud signaling APP Get dynamic password login, Or fast login through push authentication to protect account security.",
        codeTitle: "Scan the QR code below, download FEITIAN Cloud signaling APP",
        newVersion: "If it has been installed, ensure that it is the latest version",
        comingSoon: "Coming soon",
        app: "APP Have downloaded? switch",
        app2: "APP not download? switch",
        code: "Activation code",
        appCode: "Open the cloud signaling APP and click 'Scan'",
        activateCode: "Scan the activation code below and activate according to the instructions",
        downloadCode: "Download the code",
        dynamicPwd: "Verify dynamic password:",
        placeholder: "Please enter a dynamic password",
        tip: "Note: the password needs to be verified when the mobile phone is activated without Internet, otherwise it cannot be sent to the activation state!",
        subBtn: "Accomplish",
        safetyVerification: "To reset the OTP dynamic password, perform account security verification first",
    },
    webAuthn: {
        title: "FIDO2 (WebAuthn) Authenticator",
        text: "After binding, you can use Windows Hello, Touch ID or other authentcators for fast login.",
        unbind: "Bind/unbind the authenticator",
        bind: "Bind the authenticator",
        binds:"BIND",
        tip01: "You have successfully bound ",
        tip02: " authenticator(s).You can use this authenticator to quickly log in.",
        name: "Authenticator name",
        unbindTab: "UNBIND",
        tokenName: "Please enter the authenticator name",
        extent: "The authenticator name cannot be more than 32 bits long",
        noOpenMsg: "Not open Windows Hello ,Touch ID An authenticator bound to the platform",
        userErrMsg: "An error occurred while the user was validating the platform validator",
        nonsupportMsg: "An unsupported network protocol",
        nonsupportWebAuthn: "This viewer is not supported WebAuthn！.",
        httpsMsg: "WebAuthn Only secure connections are supported",
        windowClose: "Binding window Hello canceled!",
        repetitionBind: "FIDO2 (WebAuthn) Duplicate binding is not allowed!",
        arouse: "The authenticator has been invoked!",
        operationFail: "Operation failure",
        deviceExists: "FIDO2 (WebAuthn)－The identity authenticator name already exists",
        bindSuccess: "Binding success",
    },
    FIDO: {
        title: "Feitian Cloudentify APP (FIDO)",
        resetFIDO: "Reset Feitian Cloudentify APP (FIDO)",
        activateFIDO: "Activate Feitian Cloudentify APP (FIDO)",
        text: "Feitian Cloudentify APP support Fingerprint or Face Recognition for fast login.",
        tip01: "You have been successfully activated Feitian Cloudentify APP (FIDO), You can use the FEITIAN Cloud signaling APP Fingerprint or face authentication second - speed login.",
        safetyVerification: "Reset Feitian Cloudentify APP (FIDO), Please verify the account security first"
    },
    fastLogin:{
        title:"FastLogin",
        text:"Download the FastLogin client of Feitian Cloud Messenger and bind it with the account. You can log in to the portal with one click, which is more efficient.",
        down:"Download"
    }
}

export default account
